<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
#app {
  font-family: "englishFont", "苹方", "Heiti SC", Helvetica, "Microsoft Yahei",
    Droid Sans, serif !important;
}

* {
  margin: 0;
  padding: 0;
}

img {
  display: block;
}

// 导航条样式
.van-tabbar {
  box-shadow: 6px 2px 19px 3px #efecec;
  .van-tabbar-item {
    font-size: 13px;
    .van-tabbar-item__icon {
      margin-bottom: 0;
      img {
        height: 30px;
      }
    }
    .van-tabbar-item__text {
      padding-bottom: 2px;
    }
  }
}
</style>
